export default __webpack_public_path__ + "static/media/67t.daccafc7.jpg";